import { FormControl, InputLabel, Select as MaterialSelect } from '@material-ui/core/';
import classNames from 'classnames';
import React from 'react';
import useStyles from './ChowbusInput.style.js';

export default Select;
/**
 * A full select FormControl in the Chowbus style, inc. label and behavior.
 * Intented to be used with ChowbusForm
 * @see Form.jsx
 * @param {any} props
 */
function Select(props) {
  const classes = useStyles();
  const {
    id,
    passRef,
    inputClass,
    disabled,
    name,
    onChange,
    onBlur,
    value,
    error,
    fullWidth,
    label,
    children,
    margin,
    defaultValue,
    style,
  } = props;
  return (
    <FormControl
      style={style}
      margin={margin || 'normal'}
      error={error}
      classes={{ root: classes.formControl }}
      fullWidth={fullWidth}
      variant='outlined'>
      <InputLabel classes={{ root: classes.label, shrink: classes.shrink }} htmlFor={name}>
        {label}
      </InputLabel>
      <MaterialSelect
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        inputRef={passRef}
        inputProps={{ name }}
        disabled={disabled}
        labelWidth={0}
        defaultValue={defaultValue}
        classes={{
          select: classNames(classes.input, inputClass),
        }}
        style={{ backgroundColor: 'white' }}>
        {children}
      </MaterialSelect>
    </FormControl>
  );
}
